<template>
  <div class="home-container">
    <div class="main">
      <div class="top-img">
        <img
          class="img-top"
          src="../assets/img/首页-顶图.webp"
          @load="imageLoaded = true"
          @error="imageLoaded = true"
          alt=""
        />
      </div>
      <div class="main-data">
        <div v-if="sectionReady[0]">
        <div class="p1" v-if="$i18n.locale === 'zh'">
          <span>打造</span>
          <span class="col">一流专业化</span>
          <span>汽车技术公司</span>
        </div>
        <p class="p2" v-if="$i18n.locale === 'zh'">
          致力于开发撰写汽车各类技术文档；交通领域工具设备的研发、生产及服务；计算机软件开发及服务
        </p>
        <!-- 英文版 hero -->
        <div class="p2 p2-title" v-if="$i18n.locale === 'en'">
          <span class="p2-col">Our mission</span>
          <span class="p2-col-1"
            >is to establish ourselves as a premier global leader in automotive
            technology, excelling in the creation and innovation of technical
            writing, special tools and computer software for exceptional
            after-sales service.</span
          >
          <p class="p2-col-1">
            We are committed to setting new standards in research, development,
            and production, propelling the automotive industry forward with our
            cutting-edge solutions.
          </p>
        </div>
        </div><!-- /sectionReady[0] -->

        <!-- 第一部分内容 -->
        <div v-if="sectionReady[1]">
        <div class="main-ability1">
          <!-- 企业资质 -->
          <div class="ablity-li">
            <div class="ablity-li-img">
              <img src="../assets/img/专利/高新企业证书.webp" alt="" />
            </div>
            <div class="ablity-bot">
              <div class="ablity-bot-text">
                <p class="text1">{{ $t('home.certTitle1') }}</p>
                <p class="text2">{{ $t('home.certDesc1') }}</p>
              </div>
            </div>
          </div>
          <!-- 多项专利 -->
          <div class="ablity-li">
            <div class="ablity-li-img">
              <img src="../assets/img/专利/专利证书.webp" alt="" />
            </div>
            <div class="ablity-bot">
              <div class="ablity-bot-text">
                <p class="text1">{{ $t('home.certTitle2') }}</p>
                <p class="text2">{{ $t('home.certDesc2') }}</p>
              </div>
            </div>
          </div>
          <!-- 管理体系 -->
          <div class="ablity-li">
            <div class="ablity-li-img">
              <img
                class="img-3"
                src="../assets/img/专利/IOS9001认证.webp"
                alt=""
              />
            </div>
            <div class="ablity-bot">
              <div class="ablity-bot-text">
                <p class="text1">{{ $t('home.certTitle3') }}</p>
                <p class="text2">{{ $t('home.certDesc3') }}</p>
              </div>
            </div>
          </div>
        </div>
        </div><!-- /sectionReady[1] -->

        <!-- 第五部分动态展示 -->
        <div v-if="sectionReady[2]">
        <div class="main-ability5">
          <!-- <iframe class="baniframe" sandbox="allow-scripts allow-same-origin" id="mh" src="./index.html"></iframe> -->
          <div class="ability5-top">
            <p class="text1">{{ $t('home.videoTitle') }}</p>
            <p class="text2">{{ $t('home.videoDesc') }}</p>
          </div>
          <div class="ability5-main">
            <div class="ability5-main-li">
              <div class="ability5-img" @click="openDialog(0)">
                <img src="../assets/img/1.webp" alt="" />
                <div class="ability5-btn">
                  <img
                    src="../assets/img/播放.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="ability5-text">
                <p class="text1">{{ $t('home.videoItem1Title') }}</p>
                <p class="text2">{{ $t('home.videoItem1Desc') }}</p>
              </div>
            </div>

            <div class="ability5-main-li">
              <div class="ability5-img" @click="openDialog(1)">
                <img src="../assets/img/2.webp" alt="" />
                <div class="ability5-btn">
                  <img
                    src="../assets/img/播放.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="ability5-text">
                <p class="text1">{{ $t('home.videoItem2Title') }}</p>
                <p class="text2">{{ $t('home.videoItem2Desc') }}</p>
              </div>
            </div>

            <div class="ability5-main-li">
              <div class="ability5-img" @click="openDialog(2)">
                <img src="../assets/img/3.webp" alt="" />
                <div class="ability5-btn">
                  <img
                    src="../assets/img/播放.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="ability5-text">
                <p class="text1">{{ $t('home.videoItem3Title') }}</p>
                <p class="text2">{{ $t('home.videoItem3Desc') }}</p>
              </div>
            </div>

            <div class="ability5-main-li">
              <div class="ability5-img" @click="openDialog(3)">
                <img src="../assets/img/4.webp" alt="" />
                <div class="ability5-btn">
                  <img
                    src="../assets/img/播放.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="ability5-text">
                <p class="text1">{{ $t('home.videoItem4Title') }}</p>
                <p class="text2">{{ $t('home.videoItem4Desc') }}</p>
              </div>
            </div>

            <div class="ability5-main-li">
              <div class="ability5-img" @click="openDialog(4)">
                <img src="../assets/img/6.webp" alt="" />
                <div class="ability5-btn">
                  <img
                    src="../assets/img/播放.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="ability5-text">
                <p class="text1">{{ $t('home.videoItem5Title') }}</p>
                <p class="text2">{{ $t('home.videoItem5Desc') }}</p>
              </div>
            </div>

            <!-- <div class="ability5-main-li">
              <div class="ability5-img">
                <img src="../assets/img/6.webp" alt="" />
                <div class="ability5-btn">
                  <img
                    src="../assets/img/播放.png"
                    alt=""
                    @click="openDialog(5)"
                  />
                </div>
              </div>

              <div class="ability5-text">
                <p class="text1">实拍视频</p>
                <p class="text2">东风本田</p>
              </div>
            </div> -->
          </div>
          <div class="ability5-bot">
            <div class="p1">
              <span>{{ $t('home.interaction3d') }}</span>
            </div>
            <p class="p2" v-if="$i18n.locale === 'zh'">
              数字控制，实时启动，了解汽车内部结构，掌握细节，让学习更加互动，生动
            </p>
            <p class="p2-title" v-if="$i18n.locale === 'en'">
              {{ $t('home.interaction3dDesc') }}
            </p>
          </div>

          <div class="box-3d">
            <div class="btn-3dbox">
              <a
                href="https://neweinstruction.jmc.com.cn/book/jp360/3d/JMC_che/JMC_che.html"
                target="_blank"
              >
                <div class="dbtn-box btn-box1">
                  <div class="bl"></div>
                  <img src="../assets/img/3D卡片-宽1-透(3).webp" alt="" />
                </div>
              </a>
              <a href="https://forcartech.cn/3d/动力原理/动力原理.html" target="_blank">
                <div class="dbtn-box btn-box2">
                  <div class="bl"></div>
                  <img src="../assets/img/3D卡片-宽2-透(4).webp" alt="" />
                </div>
              </a>

              <a href="#" target="_blank">
                <div class="dbtn-box btn-box3">
                  <div class="bl"></div>
                  <img src="../assets/img/3D卡片-宽3-透(3).webp" alt="" />
                </div>
              </a>
            </div>
            <Three2 :top="0" class="Three2"> </Three2>
          </div>
        </div>
        </div><!-- /sectionReady[2] -->

        <!-- 第二部分内容 -->
        <div v-if="sectionReady[3]">
        <div class="main-ability2-w">
          <div class="p1">
            <span>{{ $t('home.caseTitle') }}</span>
          </div>
          <p class="p2">{{ $t('home.caseDesc') }}</p>

          <div class="main-ability2">
            <div class="ablity2-data">
              <!-- 用户手册 -->
              <div class="ablity2-data-li" @click="navigateToTarget(0)">
                <div class="ab2-img">
                  <img src="../assets/img/手册封面/相关案例1.webp" alt="" />
                </div>
                <div class="ablity2-bot">
                  <div class="ablity2-bot-text">
                    <p class="text1">{{ $t('home.caseItem1Title') }}</p>
                    <p class="text2">{{ $t('home.caseItem1Desc') }}</p>
                  </div>
                  <i class="el-icon-right"></i>
                </div>
              </div>
              <!-- 维修手册 -->
              <div class="ablity2-data-li" @click="navigateToTarget(1)">
                <div class="ab2-img">
                  <img src="../assets/img/手册封面/相关案例2.webp" alt="" />
                </div>
                <div class="ablity2-bot">
                  <div class="ablity2-bot-text">
                    <p class="text1">{{ $t('home.caseItem2Title') }}</p>
                    <p class="text2">{{ $t('home.caseItem2Desc') }}</p>
                  </div>
                  <i class="el-icon-right"></i>
                </div>
              </div>
              <!-- 拆解手册 -->
              <div class="ablity2-data-li" @click="navigateToTarget(4)">
                <div class="ab2-img">
                  <img src="../assets/img/手册封面/相关案例3.webp" alt="" />
                </div>
                <div class="ablity2-bot">
                  <div class="ablity2-bot-text">
                    <p class="text1">{{ $t('home.caseItem3Title') }}</p>
                    <p class="text2">{{ $t('home.caseItem3Desc') }}</p>
                  </div>
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </div>
            <div class="ablity2-data">
              <!-- 工时手册 -->
              <div class="ablity2-data-li" @click="navigateToTarget(5)">
                <div class="ab2-img">
                  <img src="../assets/img/手册封面/相关案例4.webp" alt="" />
                </div>
                <div class="ablity2-bot">
                  <div class="ablity2-bot-text">
                    <p class="text1">{{ $t('home.caseItem4Title') }}</p>
                    <p class="text2">{{ $t('home.caseItem4Desc') }}</p>
                  </div>
                  <i class="el-icon-right"></i>
                </div>
              </div>
              <!-- 专用工具-->
              <div class="ablity2-data-li" @click="navigateToTarget(6)">
                <div class="ab2-img">
                  <img src="../assets/img/手册封面/相关案例5.webp" alt="" />
                </div>
                <div class="ablity2-bot">
                  <div class="ablity2-bot-text">
                    <p class="text1">{{ $t('home.caseItem5Title') }}</p>
                    <p class="text2">{{ $t('home.caseItem5Desc') }}</p>
                  </div>
                  <i class="el-icon-right"></i>
                </div>
              </div>
              <!-- 培训教材教具 -->
              <div class="ablity2-data-li" @click="navigateToTarget(7)">
                <div class="ab2-img">
                  <img src="../assets/img/手册封面/相关案例6.webp" alt="" />
                </div>
                <div class="ablity2-bot">
                  <div class="ablity2-bot-text">
                    <p class="text1">{{ $t('home.caseItem6Title') }}</p>
                    <p class="text2">{{ $t('home.caseItem6Desc') }}</p>
                  </div>
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- 联系我们 -->
          <Ability3 />
        </div>
        </div><!-- /sectionReady[3] -->

        <!-- 第三部分内容 -->
        <div v-if="sectionReady[4]">
        <div class="p1">
          <span>{{ $t('home.serviceTitle') }}</span>
        </div>
        <p class="p2" v-if="$i18n.locale === 'zh'">Service Process</p>
        <div class="main-ability4"></div>

        <div class="p1 fw-p1">
          <span>{{ $t('home.advantageTitle1') }}</span><span class="col">{{ $t('home.advantageTitle2') }}</span>
        </div>
        <p class="p2">{{ $t('home.advantageDesc') }}</p>

        <!-- 第七部分 -->
        <div class="main-ability7-c">
          <div class="main-ability7">
            <img src="../assets/img/优势.webp" alt="" />
          </div>
        </div>
        </div><!-- /sectionReady[4] -->
        <!-- 第八部分 -->
        <div v-if="sectionReady[5]">
        <div class="ain-ability8-w">
          <div class="p1">
            <span>{{ $t('home.partnerTitle') }}</span>
          </div>
          <p class="p2" v-if="$i18n.locale === 'zh'">Business Partners</p>
          <div class="main-ability8">
            <div class="ability8-list">
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-1.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-2.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-3.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-4.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-15.webp" alt="" />
              </div>
            </div>
            <div class="ability8-list">
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-6.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-7.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-8.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-9-1.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/小鹏.webp" alt="" />
              </div>
            </div>
            <div class="ability8-list">
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-19.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-20.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-21.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-22.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-9-2.webp" alt="" />
              </div>
            </div>
            <div class="ability8-list">
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/东风猛士.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-11.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-12.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-13.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-14.webp" alt="" />
              </div>
            </div>
            <div class="ability8-list">
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-10.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-23.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-17.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-18.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/客户logo-5.webp" alt="" />
              </div>
            </div>
            <div class="ability8-list">
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/学校logo-1.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/学校logo-2.webp" alt="" />
              </div>
              <div class="ability8-logo">
                <img src="../assets/img/客户logo/学校logo-3.webp" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div><!-- /sectionReady[5] -->
    <el-dialog
      @close="closeDialog"
      :visible.sync="outerVisible"
      :show-close="false"
    >
      <video
        ref="videoPlayer"
        controlsList="nodownload"
        :src="videoUrl"
        controls
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import Three2 from "@/components/Three2.vue";
import Ability3 from "@/components/Ability3.vue";

export default {
  name: "HomeView",
  metaInfo() {
    return {
      title: this.$t('home.seoTitle'),
      meta: [
        {
          name: "description",
          content: this.$t('home.seoDescription'),
        },
        {
          name: "keywords",
          content: this.$t('home.seoKeywords'),
        },
      ],
    }
  },
  data() {
    return {
      outerVisible: false,
      innerVisible: false,
      videoUrl: ``,
      videoUrls: [
        require('@/assets/video/1.mp4'),
        require('@/assets/video/2-CG动画.mp4'),
        require('@/assets/video/3.mp4'),
        require('@/assets/video/4.mp4'),
        require('@/assets/video/5.mp4'),
      ],
      imageLoaded: false,
      sectionReady: [false, false, false, false, false, false],
    };
  },
  components: {
    Three2,
    Ability3,
  },
  mounted() {
    document.dispatchEvent(new Event("render-event"));
    // Progressive rendering: activate sections one by one to avoid
    // iOS Safari's monolithic DOM insertion rendering bug.
    // Each section gets its own small DOM chunk, inserted ~100ms apart.
    const delays = [0, 100, 200, 350, 500, 700];
    delays.forEach((delay, i) => {
      setTimeout(() => {
        this.$set(this.sectionReady, i, true);
      }, delay);
    });
  },

  methods: {
    openDialog(index) {
      this.outerVisible = true;
      this.videoUrl = this.videoUrls[index];
      // iOS Safari requires play() within the same user gesture tick
      this.$nextTick(() => {
        const video = this.$refs.videoPlayer;
        if (video) {
          video.play().catch(() => {}); // ignore autoplay errors
        }
      });
    },
    closeDialog() {
      this.outerVisible = false;
      this.stopVideo();
    },
    playVideo() {
      console.log("播放视频");
      this.$refs.videoPlayer.play();
    },
    stopVideo() {
      this.$refs.videoPlayer.pause();
      this.$refs.videoPlayer.currentTime = 0;
    },
    navigateToTarget(index) {
      console.log("点击跳转");
      const param = index; // 设置参数值
      this.$router.push({ path: "/case", query: { id: param } });
    },
  },
};
</script>
<style lang="scss">
.home-container {
  width: 100%;
  max-width: 100%;
  height: auto;

  // background-color:var(--red-color);
  .main {
    width: 100%;
    .main-bac {
      opacity: 0.5;
      position: absolute;
      top: 900px;
      width: 100%;
      height: 6050px;
      background-image: url("../assets/img/资源 1.svg");
      background-repeat: no-repeat;
      background-size: 110%;
      background-position: center center;
      -webkit-filter: blur(14px);
      -moz-filter: blur(14px);
      -o-filter: blur(14px);
      -ms-filter: blur(14px);
      filter: blur(14px);
      z-index: -1;
    }
    .top-img {
      width: 100%;
      height: auto;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
    .main-data {
      // 第一部分css
      .p1 .p2 {
        opacity: 0;
      }

      @media (max-width: 768px) {
        .p1 {
          min-width: auto;
          font-size: 20px;
        }

        .p2 {
          min-width: auto;
          font-size: 12px;
        }
      }

      .main-ability1 {
        max-width: 1150px;
        width: 100%;
        padding: 0 20px;
        margin: 70px auto 127px;
        display: flex;
        align-items: stretch;
        gap: 16px;

        // English text is longer, need more height
        .lang-en & {
          min-height: 550px;
        }

        @media (max-width: 1100px) {
          gap: 10px;
        }

        @media (max-width: 768px) {
          flex-direction: column;
          width: 100%;
          height: auto;
          gap: 16px;
          margin-bottom: 40px;

          .ablity-li {
            width: 100% !important;
            border-radius: 12px;
            box-shadow: 0 2px 16px rgba(0,0,0,0.06);
          }

          .ablity-bot-text {
            margin-bottom: 10px !important;

            p {
              text-align: center !important;
            }
          }
        }

        // opacity: 0;
        .ablity-li {
          flex: 1;
          min-width: 0;
          overflow: hidden;
          // background-color: rgb(255, 0, 43);
          box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.07);

          // 上半部分图片
          .ablity-li-img {
            position: relative;
            width: 100%;
            height: 70%;
            // background-color: rgb(154, 154, 154);

            overflow: hidden;

            img {
              width: 65%;
              height: auto;
              margin-top: 74px;
            }

            .img-3 {
              width: 48%;
              margin-top: 43px;
            }

            .ablity-li-title {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 0;
              overflow: hidden;
              background-color: rgb(231, 22, 41);
              transition: 0.5s;

              p {
                float: left;
                line-height: 50px;
                margin-left: 20px;
              }

              img {
                float: right;
                width: 100px;
                height: 100%;
                background-color: rgba(157, 209, 255, 0.611);
              }
            }
          }

          // 底部文字
          .ablity-bot {
            width: 100%;
            height: 20%;
            // background-color: aliceblue;
            margin-top: 21px;
            display: flex;

            .ablity-bot-text {
              margin: 0 auto;
              width: 84%;
              height: 100%;

              // background-color: rgba(180, 44, 23, 0.611);
              // padding: 10px;
              p {
                text-align: left;
                margin: 2px;
              }

              .text1 {
                font-size: 23px;
                // font-weight: 700;
                .lang-en & {
                  font-size: 18px;
                }
              }

              .text2 {
                margin-top: 15px;
                font-size: 0.85rem;
                word-break: break-word;
                .lang-en & {
                  font-size: 0.75rem;
                  line-height: 1.4;
                }
              }
            }
          }
        }
      }

      // 第二部分css
      .main-ability2-w {
        width: 100%;
        height: auto;
        background-color: rgb(246, 247, 251);
        padding-top: 10px;
        border: 1px solid rgba(255, 255, 255, 0);
        margin-bottom: 1px;

        .main-ability2 {
          max-width: 1150px;
          width: 90%;
          // min-width: 1150px;
          height: auto;
          min-height: 400px;
          margin: 70px auto;

          @media (max-width: 768px) {
            height: auto;
            width: 100%;
          }

          .ablity2-data {
            width: 100%;
            height: auto;
            margin-top: 8px;
            display: flex;
            justify-content: space-between;

            // Mobile: single column
            @media (max-width: 768px) {
              flex-direction: column;
            }

            .ablity2-data-li {
              flex: 1;
              cursor: pointer;
              transition: 0.5s;
              margin-right: 5px;
              min-width: 0;

              &:last-child { margin-right: 0; }

              @media (max-width: 768px) {
                width: 100%;
                margin-right: 0;
                margin-bottom: 10px;
              }

              .ab2-img {
                width: 100%;
                height: 80%;
                overflow: hidden;

                .lang-en & { height: 75%; }

                @media (max-width: 1100px) {
                  height: 70%;
                }

                img {
                  transition: 0.5s;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              .ablity2-bot {
                width: 100%;
                height: 20%;
                transition: 0.2s;
                background: #fff;

                .lang-en & { height: 35%; }

                @media (max-width: 1100px) {
                  height: 30%;
                  .lang-en & { height: 40%; }
                }

                .ablity2-bot-text {
                  width: calc(100% - 50px);
                  height: 100%;
                  float: left;
                  padding: 0 16px;

                  p {
                    text-align: left;
                    margin: 4px 0;
                  }

                  .text1 {
                    font-size: 18px;
                    margin-bottom: 0;
                    @media (max-width: 1200px) { font-size: 15px; }
                    @media (max-width: 900px) { font-size: 13px; }
                    .lang-en & {
                      font-size: 15px;
                      @media (max-width: 1200px) { font-size: 13px; }
                      @media (max-width: 900px) { font-size: 11px; }
                    }
                  }

                  .text2 {
                    margin-top: 6px;
                    font-size: 0.85rem;
                    @media (max-width: 1200px) { font-size: 0.78rem; }
                    @media (max-width: 900px) { font-size: 0.7rem; }
                    .lang-en & {
                      font-size: 0.75rem;
                    }
                  }
                }

                i {
                  float: right;
                  font-size: 24px;
                  line-height: 65px;
                  margin-right: 12px;

                  @media (max-width: 900px) {
                    font-size: 18px;
                    line-height: 50px;
                  }
                }
              }

              @media (hover: hover) {
                &:hover {
                  .ablity2-bot {
                    background: #fef0f0;
                    border-top: 2px solid #d53434;

                    .ablity2-bot-text {
                      color: #1a1a1a;
                    }

                    i {
                      color: #d53434;
                    }
                  }

                  .ab2-img img {
                    transform: scale(1.08);
                  }
                }
              }
            }
          }
        }
      }

      .fw-p1 {
        margin-top: 118px;
      }

      .main-ability4 {
        max-width: 1150px;
        width: 100%;
        padding: 0 20px;
        height: 300px;
        margin: 10px auto;
        margin-bottom: 80px;
        background-image: url("../assets/img/服务流程图.svg");
        background-size: 100%;
        background-position: center;
        background-repeat: no-repeat;

        @media (max-width: 1200px) {
          height: 220px;
        }

        @media (max-width: 768px) {
          width: 80%;
          height: 140px;
          margin: 0 auto;
        }
      }

      // 第五部分

      .main-ability5 {
        width: 100%;
        height: auto;
        background-color: rgb(0, 14, 20);
        position: relative;

        @media (max-width: 768px) {
          height: 100%;
        }

        .ability5-bot {
          color: #fff;
        }

        .box-3d {
          width: 100%;
          height: auto;
          min-height: 500px;
          margin-top: 88px;
          position: relative;

          @media (max-width: 768px) {
            margin-top: 40px;
          }

          .btn-3dbox {
            position: relative;
            width: 100%;
            max-width: 1400px;
            margin: 0 auto;
            z-index: 2;
            display: flex;
            gap: 24px;
            padding: 0 80px;

            @media (max-width: 1200px) {
              padding: 0 40px;
              gap: 16px;
            }

            @media (max-width: 768px) {
              flex-direction: column;
              padding: 0 20px;
              gap: 16px;
            }

            a {
              flex: 1;
              max-width: 450px;
              aspect-ratio: 4 / 3;
              margin: 0 auto;

              @media (max-width: 768px) {
                flex: none;
                width: 100%;
                max-width: 100%;
                aspect-ratio: 16 / 9;
                margin: 0;
              }

              .dbtn-box {
                position: relative;
                border-radius: 10px;
                overflow: hidden;
                transition: 0.2s;
                width: 100%;
                height: 100%;
                cursor: pointer;

                .bl {
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  -webkit-backdrop-filter: saturate(150%) blur(0.808333rem);
                  backdrop-filter: saturate(150%) blur(0.308333rem);
                }

                img {
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  object-fit: cover;
                }
              }

              &:nth-child(3) {
                pointer-events: none;
              }
            }

            .btn-box1 {
              border: 2px solid rgba(83, 240, 193, 0.8);

              @media (hover: hover) {
                &:hover {
                  box-shadow: 0 0 31px 10px rgba(83, 240, 193, 0.8);
                }
              }

              .bl {
                // background: linear-gradient(
                //   to bottom,
                //   #00ff0000,
                //   rgba(83, 240, 193, 0.542),
                //   rgba(83, 240, 193, 0.042)
                // );
                background-color: rgba(83, 240, 193, 0.45);
              }
            }

            .btn-box2 {
              border: 2px solid rgba(217, 142, 255, 0.8);

              @media (hover: hover) {
                &:hover {
                  box-shadow: 0 0 31px 10px rgba(142, 69, 246, 0.8);
                }
              }

              .bl {
                // background: linear-gradient(
                //   to bottom,
                //   #00ff0000,
                //   rgba(142,69,246, 0.242)
                // );
                background-color: rgba(142, 69, 246, 0.45);
              }
            }

            .btn-box3 {
              border: 2px solid rgba(68, 234, 255, 0.8);

              @media (hover: hover) {
                &:hover {
                  box-shadow: 0 0 31px 10px rgba(0, 166, 224, 0.8);
                }
              }

              .bl {
                // background: linear-gradient(
                //   to bottom,
                //   #00ff0000,
                //   rgba(0,166,224, 0.242)
                // );
                background-color: rgba(0, 166, 224, 0.45);
              }
            }
          }

          .Three2 {
            height: 600px;
            margin-top: -13%;
            position: absolute;
            bottom: 0;

            //  pointer-events: none;
            @media (max-width: 768px) {
              margin-top: -66%;
            }
          }
        }

        .ability5-top {
          max-width: 1150px;
          width: 90%;
          height: auto;
          margin: auto;
          color: aliceblue;
          text-align: left;
          padding-top: 85px;

          .text1 {
            font-size: 40px;
            margin: 0;
          }
        }

        .ability5-main {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          margin-top: 60px;

          @media (max-width: 768px) {
            flex-direction: column;
          }

          .ability5-main-li {
            flex: 1;
            margin-left: 10px;
            overflow: hidden;
            transition: flex 0.4s ease;

            &:first-child { margin-left: 0; }

            @media (max-width: 768px) {
              margin-left: 0;
              margin-bottom: 20px;
            }

            .ability5-img {
              border: 0.5px solid rgb(201, 184, 136);
              position: relative;
              width: 100%;
              height: 420px;
              overflow: hidden;
              cursor: pointer;

              @media (max-width: 1400px) {
                height: 340px;
              }

              @media (max-width: 1100px) {
                height: 260px;
              }

              @media (max-width: 768px) {
                height: 280px;
              }

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: 0.5s;
                filter: grayscale(50%);

                @media (max-width: 768px) {
                  filter: grayscale(30%);
                }
              }

              .ability5-btn {
                position: absolute;
                inset: 0;
                display: flex;
                transition: 0.3s;

                img {
                  width: 45px;
                  height: auto;
                  margin: auto;
                  cursor: pointer;
                  opacity: 0;
                  transition: opacity 0.3s, transform 0.3s;
                }
              }
            }

            .ability5-text {
              color: rgb(201, 184, 136);
              text-align: left;

              p {
                margin-left: 20px;
                margin-right: 10px;
              }

              .text1 {
                font-size: 18px;
                margin-top: 20px;
                margin-bottom: 10px;
                @media (max-width: 1400px) { font-size: 16px; }
                @media (max-width: 1100px) { font-size: 14px; margin-top: 14px; }
                .lang-en & {
                  font-size: 14px;
                  @media (max-width: 1400px) { font-size: 13px; }
                  @media (max-width: 1100px) { font-size: 11px; }
                }
              }

              .text2 {
                font-size: 0.85rem;
                margin-top: 0;
                @media (max-width: 1400px) { font-size: 0.78rem; }
                @media (max-width: 1100px) { font-size: 0.7rem; }
                .lang-en & {
                  font-size: 0.75rem;
                }
              }
            }

            @media (hover: hover) {
              &:hover {
                flex: 1.6;

                .ability5-img img {
                  filter: grayscale(0%);
                  transform: scale(1.08);
                }

                .ability5-btn img {
                  opacity: 1;
                  transform: scale(1.1);
                }
              }
            }

            // Always show play button on touch devices (no hover capability)
            @media (hover: none) {
              .ability5-btn img {
                opacity: 0.8;
              }
            }
          }
        }
      }

      // 第六部分 3D部分

      // 第七部分
      // .main-ability7-c{
      //   width: 60%;
      //   display: flex;
      //   margin: auto;
      // }
      .main-ability7 {
        // width: 60%;
        max-width: 1150px;
        width: 100%;
        padding: 0 20px;
        height: auto;
        margin: 60px auto;
        margin-bottom: 128px;

        @media (max-width: 768px) {
          width: 100%;
        }

        img {
          width: 100%;
          height: auto;
        }
      }

      .ain-ability8-w {
        width: 100%;
        min-width: auto;
        background-color: rgb(223, 221, 221);
        background-image: url("../assets/img/LOGO背景_画板_1.webp");
        background-size: 130%;
        background-position: top;
        padding-top: 10px;
        padding-bottom: 290px;

        @media (max-width: 768px) {
          min-width: auto;
          height: 100%;
        }

        .main-ability8 {
          max-width: 1150px;
          width: 100%;
          padding: 0 20px;
          height: auto;
          margin: 70px auto;
          margin-bottom: 0px;

          @media (max-width: 768px) {
            width: 100%;
            height: auto;
            min-width: auto;
          }

          .ability8-list {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 20px;
            margin-bottom: 20px;

            &:last-child {
              grid-template-columns: repeat(3, 1fr);
            }

            @media (max-width: 1200px) {
              gap: 16px;
            }

            @media (max-width: 768px) {
              gap: 10px;
              margin-bottom: 12px;
            }

            @media (max-width: 500px) {
              grid-template-columns: repeat(5, 1fr);
              gap: 6px;
            }

            .ability8-logo {
              background: #fff;
              border-radius: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              min-width: 0;
              box-shadow: 0 1px 4px rgba(0,0,0,0.04);
              transition: transform 0.2s, box-shadow 0.2s;

              img {
                width: 100%;
                height: auto;
                object-fit: contain;
              }

              @media (hover: hover) {
                &:hover {
                  transform: scale(1.03);
                  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
                }
              }
            }
          }
        }
      }
    }
  }
}

// Only apply dialog backdrop blur on devices with hover (desktop).
// On touch devices (iOS/Android), backdrop-filter on fixed fullscreen
// wrapper creates a GPU compositor layer that blocks all touch events.
@media (hover: hover) {
  .el-dialog__wrapper {
    backdrop-filter: saturate(150%) blur(0.208333rem);
  }
}

.el-dialog {
  background: rgba(0, 0, 0, 0) !important;
  box-shadow: none !important;
  width: 60% !important;

  @media (max-width: 768px) {
    width: 90% !important;
  }

  .el-dialog__body {
    @media (max-width: 768px) {
      padding: 0;
    }
  }

  video {
    width: 100%;
    height: auto;
    border: 1px solid rgb(201, 184, 136);
  }
}

@media (max-width: 768px) {
  .home-container .main .top-img {
    min-width: auto;
  }
}
</style>
